import { DevicesAPI, IGetDeviceByNameParams } from "../../services/hcnApi";

export const rebootDeviceUseCase = async (params: IGetDeviceByNameParams) => {
  await DevicesAPI.rebootDevice(params);
};
